import { provideHttpClient, withFetch } from '@angular/common/http';
import { ApplicationConfig } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { provideApollo } from "./provide-apollo";

export const appConfig: ApplicationConfig = {
  providers: [provideApollo(),provideHttpClient(withFetch()), provideRouter(routes), provideClientHydration()]
};
